export default Object.freeze({
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  BASE_URL: process.env.BASE_URL,
  API: {
    URL: process.env.API_URL || '',
    IDENTITY: process.env.API_IDENTITY || '',
    CONNECT: process.env.API_CONNECT || '',
    MONITOR: process.env.API_MONITOR || '',
  },
  ROLLBAR: {
    POST_CLIENT_TOKEN: process.env.ROLLBAR_TOKEN || '',
  },
  HWY_ONBOARD_URL: process.env.HWY_ONBOARD_URL,
  ENV_URL: process.env.ENV_URL,
  HELP_URL: process.env.HELP_URL,
  PERSONA: {
    TEMPLATE_ID: process.env.PERSONA_TEMPLATE_ID,
    ENVIRONMENT_ID: process.env.PERSONA_ENVIRONMENT_ID,
  },
  DISABLE_IDV_TEST_FLOW: process.env.DISABLE_IDV_TEST_FLOW,
});
